import { LARGER } from './breakpoint-controller'
var $ = window.jQuery;
let header , win;
var paddingTop , target , scrollTarget;

function onDocumentReady() {
    win = $(window);
    header = $('#header');
    paddingTop = 120;
    win.on('load scroll', function(){
        if(win.width() >= LARGER){
            if ($(this).scrollTop() >= 50) {
                header.addClass('header-sticky');
            }
            else{
                header.removeClass('header-sticky');
            }
        }
    });
}

$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/synergy/assets/scripts/source/scroll-controller.js